// ============================================================
// 宝石实体
// ============================================================
import * as THREE from 'three';
import { GEM_BOB_AMPLITUDE, GEM_ROTATE_SPEED } from '../config';

export class Gem {
  readonly group = new THREE.Group();
  readonly worldPos = new THREE.Vector3();
  active = true;
  private baseY: number;

  private static readonly gemGeometry = new THREE.OctahedronGeometry(0.35, 0);
  private static readonly gemMaterial = new THREE.MeshStandardMaterial({
    color: '#ffcc00',
    roughness: 0.2,
    metalness: 0.9,
    emissive: '#443300',
    emissiveIntensity: 0.5,
  });

  private mesh: THREE.Mesh;
  private glowLight: THREE.PointLight;

  constructor(x: number, y: number, z: number) {
    this.baseY = y;
    this.worldPos.set(x, y, z);

    this.mesh = new THREE.Mesh(Gem.gemGeometry, Gem.gemMaterial);
    this.mesh.castShadow = true;
    this.group.add(this.mesh);

    // 光晕
    this.glowLight = new THREE.PointLight('#ffaa00', 0.6, 2.5);
    this.group.add(this.glowLight);

    this.group.position.copy(this.worldPos);
  }

  update(delta: number, elapsed: number): void {
    if (!this.active) {
      // 收集动画：缩小消失
      const s = Math.max(0, this.group.scale.x - delta * 3);
      this.group.scale.setScalar(s);
      if (s <= 0) {
        this.group.visible = false;
        this.glowLight.intensity = 0;
      }
      return;
    }

    // 上下浮动
    this.group.position.y = this.baseY + Math.sin(elapsed * 3) * GEM_BOB_AMPLITUDE;
    // 旋转
    this.group.rotation.y += GEM_ROTATE_SPEED * delta;
    this.group.rotation.x += GEM_ROTATE_SPEED * 0.5 * delta;
  }

  collect(): void {
    this.active = false;
    this.glowLight.intensity = 0;
  }

  dispose(): void {
    this.glowLight.dispose();
  }
}
